import React, { memo, useEffect, useState } from 'react';

import { bindActionCreators } from 'redux';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { toastr } from 'react-redux-toastr';

import Select from 'react-select';
import closeIcon from '../../../img/fechar.svg';

import { IaCreators } from '../../../../../store/actions/intelligence';

import './index.css';

function ModalAprimoramento(props) {
  const { user } = props;
  const [showOptions, setShowOptions] = useState('');
  const [options, setOptions] = useState(null);
  const [option, setOption] = useState(null);

  useEffect(() => {
    setShowOptions(props.showOptions);
    if (props.showOptions === 'intent')
      props.listIAIntents(props.bot.currentTokenIa);
    else props.listIAEntities(props.bot.currentTokenIa);
    return () => {
      setShowOptions('');
      setOptions(null);
      setOption(null);
    };
  }, []);

  useEffect(() => {
    setOptions(
      props?.intents.map((intent) => {
        return { name: 'intent', label: intent.name, value: intent.name };
      })
    );
  }, [props.intents]);

  useEffect(() => {
    setOptions(
      props?.entities.map((entity) => {
        return { name: 'entity', label: entity.name, value: entity.name };
      })
    );
  }, [props.entities]);

  const handleClickButton = () => {
    if (option) {
      if (props.typeAprimoramento === 'existente')
        if (showOptions === 'intent')
          props.setAprimoramentos({
            type: 'ADD_SAMPLE_INTENT',
            payload: {
              token: props.bot.currentTokenIa,
              text: props.selectedPart,
              name: option.label,
            },
          });
        else
          props.setAprimoramentos({
            type: 'ADD_SAMPLE_ENTITY',
            payload: {
              token: props.bot.currentTokenIa,
              text: props.selectedPart,
              name: option.label,
            },
          });
      else if (showOptions === 'intent') {
        if (props.intents.some((intent) => intent.name === option))
          return toastr.error(
            'Ops!',
            'Já existe uma intenção criada com este nome'
          );
        props.setAprimoramentos({
          type: 'ADD_INTENT',
          payload: {
            token: props.bot.currentTokenIa,
            text: props.selectedPart,
            name: option,
          },
        });
      } else {
        if (props.entities.some((entity) => entity.name === option))
          return toastr.error(
            'Ops!',
            'Já existe uma entidade criada com este nome'
          );
        props.setAprimoramentos({
          type: 'ADD_ENTITY',
          payload: {
            token: props.bot.currentTokenIa,
            text: props.selectedPart,
            name: option,
          },
        });
      }
      props.setTypeAprimoramento('');
    } else {
      toastr.error('Ops', 'Escolha uma Opção ou Digite algo');
    }
  };

  return (
    <div className="container-modal-aprimoramento">
      <div className="modal-aprimoramento">
        <div className="modal-aprimoramento-title">
          {`${
            props.typeAprimoramento === 'existente'
              ? 'Adicionar exemplo a'
              : 'Criar nova'
          } ${showOptions === 'intent' ? 'intenção' : 'entidade'}`}
          <img
            alt="closeModalAprimoramento"
            src={closeIcon}
            onClick={
              user?.selectedCompany?.claim?.name !== 'Viewer'
                ? () => props.setTypeAprimoramento('')
                : ''
            }
          />
        </div>
        <div className="modal-aprimoramento-container-input">
          "{props.selectedPart}" pertence a:
          {props.typeAprimoramento === 'existente' ? (
            <Select
              disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
              placeholder="Selecione..."
              className="condition-select"
              isClearable
              isSearchable
              onChange={
                user?.selectedCompany?.claim?.name !== 'Viewer'
                  ? (option) => setOption(option)
                  : ''
              }
              value={option}
              options={options}
            />
          ) : (
            <div className="modal-aprimoramento-container-input">
              <input
                disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
                placeholder={`digite nova ${
                  showOptions === 'intent' ? 'intenção' : 'entidade'
                }`}
                value={option}
                onChange={(e) => setOption(e.target.value)}
              />
            </div>
          )}
        </div>
        <div className="modal-aprimoramento-container-button">
          <button
            onClick={
              user?.selectedCompany?.claim?.name !== 'Viewer'
                ? handleClickButton
                : ''
            }
          >
            {props.typeAprimoramento === 'existente' ? 'salvar' : 'criar'}
          </button>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
  intents: state.intelligence.intents,
  entities: state.intelligence.entities,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...IaCreators,
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(memo(ModalAprimoramento)))
);
